<template>
  <help-dialog title="Home Dashboard">
    <template #activator="{ openDialog }">
      <v-btn
        variant="text"
        icon="mds:help"
        class="mr-4"
        @click="openDialog"
      />
    </template>

    <template #default>
      <h3 class="mb-1 text-black">Welcome to Your Home Dashboard!</h3>
      <p class="text-grey-darken-3">
        Here, you can manage all your projects. Let’s go over the key areas.
      </p>

      <br><br>

      <h3 class="mb-1 text-black">Recent workflows</h3>
      <p class="text-grey-darken-3">
        At the top, you can quickly access your most recent workflows (if any exist). Clicking on a workflow takes you directly to it—no need to select a project or visit the project dashboard first.
      </p>

      <br><br>

      <h3 class="mb-1 text-black">All projects</h3>
      <p class="text-grey-darken-3">
        In this section, you’ll see all your projects. Each project can contain multiple workflows. When you share access with your team members, it is done on project level, team members will gain access to all the workflows in the project. Click on any project to visit its project dashboard.
      </p>

      <br><br>

      <h3 class="mb-1 text-black">Quick Tips</h3>
      <ul class="ml-4">
        <li><b>Workflows and Projects:</b> Workflows (that you have edit rights to) and projects (that you own) have a context menu with actions such as Edit and Delete. For workflows, the menu is displayed when you hover over the workflow card. You can also quickly copy workflows using the same menu.</li>
        <li><b>Help:</b> If you ever need assistance, just click the question mark icon <v-icon size="small">mds:help</v-icon> wherever you see it for helpful, context-specific guidance.</li>
      </ul>

      <br><br>

      <h3 class="mb-0 text-black">Reach out to us</h3>
      <v-list density="compact">
        <v-list-item
          href="https://webforms.pipedrive.com/f/6NfI0XGDzXIe8nGmpN1ly8pQUw2YUXE6GnPVoWuCyliiWcg13YOiNmQBCeX3PF6nbJ"
          target="_blank" rel="noopener noreferrer" prepend-icon="mds:support">
          <v-list-item-title>Contact support</v-list-item-title>
        </v-list-item>
      </v-list>

    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  }
}
</script>
